import { useMutation, useQuery } from '@tanstack/react-query';

import { getAuthorDictionary, getCategoryDictionary, updateAnalytic } from '../../../../api';
import { Analytic } from '../../../../types/analytic';

export const useAuthors = () => useQuery({ queryKey: ['getAuthorDictionary'], queryFn: getAuthorDictionary });
export const useCategories = () => useQuery({ queryKey: ['getCategoryDictionary'], queryFn: getCategoryDictionary });

export const useUpdateAnalytic = () =>
  useMutation({ mutationKey: ['updateAnalytic'], mutationFn: (data: Partial<Analytic>) => updateAnalytic(data) });
